<template>
  <div class="footer">
    <!-- <div v-for="( item  , index ) in imgUrl" :key="index">
      <img :src="item" alt="">
    </div> -->
  </div>
</template>

<script>
export default {
  name:"MainFooter",
  data(){
    return{
      imgUrl:[
        // require('@/assets/image/XSYD.png'),
        // require('@/assets/image/ZNLS.png'),
        // require('@/assets/image/SJGL.png'),
        // require('@/assets/image/VIP.png'),
        // require('@/assets/image/ZZSF.png'),
        // require('@/assets/image/ZSDZ.png')
      ]
    }
  }
}
</script>

<style lang="less">
.footer{
  height: 30%;
  display: flex;
  justify-content: space-around;
  div{
    position: relative;
    z-index: 1;
  }
}
</style> 